import { createStore } from 'vuex';
import { getUserInfo, getMenu, getDict } from '@/service/api';
import { showFailToast } from 'vant';

export default createStore({
  state: {
    openId: null,
    userInfo: null,
    menus: null,
    allMenus: new Map(),
    dicts: {},
    paramsDicts: {},
    inited: false
  },
  getters: {
    hasLogin(state) {
      return !!state.userInfo;
    },
    hasDic(state) {
      return !!Object.keys(state.dicts).length;
    }
  },
  mutations: {
    setUserInfo(state, info) {
      state.userInfo = info;
    },
    setAllMenus(state, menus) {
      menus.forEach(m => {
        state.allMenus.set(m.authCode, true);
        if (m.children) {
          this.commit('setAllMenus', m.children);
        }
      })
    },
    setMenus(state, menus) {
      state.menus = menus;
      state.allMenus.clear();
      this.commit('setAllMenus', menus || []);
    },
    setDict(state, dicts) {
      state.dicts = dicts;
    },
    setParams(state, dicts) {
      state.paramsDicts = dicts;
    },
    setInited(state) {
      state.inited = true;
    },
    setOpenId(state, openId) {
      state.openId = openId;
    }
  },
  actions: {
    getUserInfo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Promise.all([getUserInfo(payload)])
          .then(([userInfo]) => {
            // userInfo.role='cheng'
            commit('setUserInfo', userInfo);
            commit('setOpenId', userInfo.openid);
            commit('setInited');
            resolve();
          })
          .catch(() => {
            commit('setUserInfo', null);
            reject();
          })
      })
    },
    getDictInfo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getDict({
          categoryCodes: payload
        }).then(res => {
          Object.keys((res || {})).forEach(key => {
            res[key] = res[key].map(item => ({
              text: item.title,
              value: item.value
            }))
          })
          commit('setDict', Object.assign({}, res));
          resolve();
        }).catch(() => {
          commit('setDict', {});
          resolve();
        });
      })
    },
    // getParamsInfo({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     getParamsDict().then(res => {
    //       commit('setParams', res);
    //       resolve();
    //     }).catch(() => {
    //       commit('setParams', {});
    //       resolve();
    //     });
    //   })
    // },
  },
  modules: {
  }
})
